import React, { Component } from 'react'
import * as firebase from "firebase/app";
import "firebase/auth";
import { withRouter } from 'react-router-dom'
import { saveToken } from '../../utils/authToken';
import Header from '../../components/Header';

class Login extends Component {
  state = {
    username: '',
    password: '',
    loading: false,
  }

  updateInput = (evt) => {
    this.setState({
      ...this.state,
      [evt.target.name]: evt.target.value
    })
  }
  login = (e) => {
    e.preventDefault();

    this.setState({
      ...this.state,
      loading: true
    })

    const { username, password } = this.state;

    firebase.auth().signInWithEmailAndPassword(username, password).then(async data => {
      saveToken(await data.user.getIdToken(true));
      this.setState({
        ...this.state,
        loading: false
      });
      this.props.history.push('/dashboard')
    }).catch(function (error) {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(`Error ${errorCode}: ${errorMessage}`);
    });
  }
  render() {
    return (
      <div>
        <Header />
        <form onSubmit={this.login}>
          <h1>Login to your Account</h1>
          <input type="email" name="username" placeholder="Email" value={this.state.username} onChange={this.updateInput} autoComplete="email" />
          <input type="password" name="password" placeholder="Your Secret" value={this.state.password} onChange={this.updateInput} autoComplete="current-password" />
          <button type="submit">Sign In</button>
        </form>
      </div>
    )
  }
}

export default withRouter(Login);
